module.exports = __webpack_public_path__ + "9b31be907a3ec8b8eda2c564489f7ea0.MP3";